import { ViewportScroller } from '@angular/common';
import { Component, Input, effect, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { EButtonColors } from '../sections/section.interface';
import { GoogleAnalyticsService } from 'src/app/core/google-analytics/google-analytics.service';
import { ICTA } from './cta.interface';
import { toSignal } from '@angular/core/rxjs-interop';
import { SafePipe } from 'src/app/core/safe/safe.pipe';

@Component({
  selector: 'app-cta',
  templateUrl: './cta.component.html',
  styleUrl: './cta.component.scss',
  imports: [
    RouterModule,
    SafePipe,
  ],
})
export class CtaComponent {
  @Input() public cta?: ICTA;

  private readonly _viewportScroller: ViewportScroller = inject(ViewportScroller);
  private readonly _route: ActivatedRoute = inject(ActivatedRoute);
  private readonly _googleAnalyticsService: GoogleAnalyticsService = inject(GoogleAnalyticsService);

  public readonly EButtonColors: typeof EButtonColors = EButtonColors;

  public fragment$ = toSignal(this._route.fragment);

  constructor() {
    effect(() => {
      this.goToAnchor(this.fragment$());
    });
  }

  public goToAnchor(id: string | null | undefined): void {
    if (id) {
      this._viewportScroller.scrollToAnchor(id);
    }
  }

  public handleAnalytics(event: MouseEvent, cta: ICTA): void {
    if (cta?.download) {
      this._googleAnalyticsService.event('file_download', {
        file_extension: cta.downloadExtension,
        file_name: cta.downloadFileName,
        link_domain: window.location.href,
        link_url: cta.href,
        link_text: (event.currentTarget as HTMLElement).innerText,
      });
    }
  }
}
